export default "__VITE_ASSET__XphlHPSx__"